  <div [class.error]="error">
  <svg [style.width]="width" [style.height]="height">
    <circle [attr.cx]="cx" [attr.cy]="cy" [attr.r]="r" fill="transparent" id="radius" />
    <circle *ngIf="!data || data.length === 0" [attr.cx]="cx" [attr.cy]="cy" [attr.r]="r" fill="transparent" [attr.stroke-width]="stroke_width" stroke="lightgray" />
    <circle *ngFor="let d of data; let i = index" fill="transparent" [attr.cx]="cx" [attr.cy]="cy" [attr.r]="r" fill="transparent"
      [attr.stroke-width]="stroke_width" [attr.stroke]="d.color" [attr.stroke-dasharray]="calculateStrokes(d.value, i).stroke_dash_array"
      [attr.stroke-dashoffset]="calculateStrokes(d.value, i).stroke_dash_offset" />
    <text text-anchor="middle" class="svg-content">
      <!--<tspan x="50%" y="50%" class="label-main error-label" *ngIf="totalValue === 0">00</tspan>-->
      <tspan x="50%" y="50%" class="label-main">{{totalValue}}</tspan>
      <tspan x="50%" y="50%" dy="24px" class="label-secondary">{{label}}</tspan>
    </text>
    <text text-anchor="middle" class="svg-content-error">
      <tspan x="50%" y="55%" class="label-main error-label">00</tspan>
      <tspan x="50%" y="50%" dy="24px" class="label-secondary  error-label">{{label}}</tspan>
    </text>
    <image x="42%" y="25%" width="30" height="30" class="svg-content-error" xlink:href="/assets/img/293863_Lucy_Dvs_006_ADDPDashboard_donut_error_.png"
    />
  </svg>
</div>
